
import { CookieConstants } from "../constants/local"
import cookie from 'react-cookies';
import { AuthService } from "../services/auth.service";

export enum PERMISSION {
	Admin = "stec_admin",
	LossEvent = "stec_erm_loss_event",
	ScenarioAssessment = "stec_erm_scenario_assessment",
	Approver = "stec_approver",
	ERM = "stec_erm",
	ClientAdmin = "client_admin"
}

const hasPermission = (expectRoles: PERMISSION[]) => {

	if (!expectRoles || expectRoles.length === 0) return true

	const permissions = cookie.load(CookieConstants.PERMISSIONS) as PERMISSION[];
	if (!permissions || !permissions.length) return false;

	if (permissions.includes(PERMISSION.Admin)) {
		return true;
	}

	const intersection = permissions.filter(function (v: any) {
		// check element present in the second array
		return expectRoles.indexOf(v) > -1;
	})

	return intersection.length !== 0;
}

const isAdmin = () => {
	const permissions = cookie.load(CookieConstants.PERMISSIONS) as PERMISSION[];
	if (!permissions) return false;
	return permissions.includes(PERMISSION.Admin);
}

const isCurrentUser = (userName: string | undefined) => {
	const user = AuthService.getUserInfo();
	return !!userName && !!user?.username && userName === user?.username;
}


const isApprover = (approverName: string | undefined) => {
	const user = AuthService.getUserInfo();
	return !!approverName && (approverName === user?.username || approverName === user?.email_address)
}

const hasApproverRole = () => {
	const permissions = cookie.load(CookieConstants.PERMISSIONS) as PERMISSION[];
	if (!permissions) return false;
	return permissions.includes(PERMISSION.Approver);
}

export const ROLE_GUARD = {
	isAdmin,
	hasPermission,
	isApprover,
	isCurrentUser,
	hasApproverRole
}